import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, ArrowRight } from "lucide-react";

export default function CryptoReturn() {
  return (
    <div className="min-h-screen flex items-center justify-center px-5 pt-28">
      <div className="max-w-lg w-full text-center" data-testid="crypto-return-page">
        <div className="relative inline-flex mb-6">
          <CheckCircle2 size={56} className="text-accent" />
        </div>
        <span className="font-mono-tech text-xs tracking-[0.3em] uppercase text-accent">
          / Payment received
        </span>
        <h1 className="font-display font-black text-5xl tracking-tighter mt-3 leading-none">
          ORDER CONFIRMED
        </h1>
        <p className="text-zinc-300 mt-5 leading-relaxed">
          Thanks — your payment went through and your order is locked in. You'll receive an email
          confirmation shortly, and your order will be prepared for cold-packed dispatch with free
          tracked shipping (7–14 business days).
        </p>
        <div className="flex flex-wrap items-center justify-center gap-3 mt-8">
          <Link
            to="/shop"
            className="inline-flex items-center gap-2 bg-accent hover:bg-accent-hover text-white font-display font-bold uppercase tracking-wide px-7 py-4 transition-colors clip-corner"
          >
            Continue Shopping <ArrowRight size={18} />
          </Link>
          <Link
            to="/rewards"
            className="inline-flex items-center gap-2 border border-white/25 hover:border-white text-white font-display font-bold uppercase tracking-wide px-7 py-4 transition-colors"
          >
            View Rewards
          </Link>
        </div>
      </div>
    </div>
  );
}
